import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Cases.module.css";
import { casesActions } from "@_actions/cases.actions";
import config from "@_configs/api.config";
import CasesRow from "@_components/CaseRow/CaseRow";
import SearchByType from "@_components/SearchByType/SearchByType";
import CaseDetails from "@_components/CaseDetails/CaseDetails";
import { caseActions } from "@_actions/case.actions";
import AddCasePopup from "@_components/popups/AddCasePopup/AddCasePopup";
import caseStates from "@_configs/caseStates.config";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  AirlineSeatFlat,
  ArrowDownward,
  ArrowUpward,
  EventBusy,
  EventBusyOutlined,
  FilterList,
  InsertDriveFileOutlined,
  Mail,
  PanTool,
  TimerOffTwoTone,
  Warning,
} from "@mui/icons-material";
import { ClickAwayListener, Paper, Tooltip } from "@mui/material";
import { caseConstants } from "@_constants/case.constants";
import "scrollbar.css";
import Scrollbar from "react-perfect-scrollbar-z";
import { sidebarActions } from "@_actions/sidebar.actions";
import { customerActions } from "@_actions/customer.actions";
import CasesReportPopup from "@_components/popups/CasesReportPopup/CasesReportPopup";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

function Cases() {
  const casesReducer = useSelector((state) => state.casesReducer);
  const sidebarReducer = useSelector((state) => state.sidebarReducer);
  const caseReducer = useSelector((state) => state.caseReducer);

  const [searchValue, setSearchValue] = useState("");
  const [selectedSearchTag, setSelectedSearchTag] = useState(null);
  const [loadNow, setLoadNow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSearchObject, setCurrentSearchObject] = useState({});
  const [filterOverdueReminder, setFilterOverdueReminder] = useState(false);
  const [filterUnreadMails, setFilterUnreadMails] = useState(false);
  const [filterUploadedLicenses, setFilterUploadedLicenses] = useState(false);
  const [filterFailedEmails, setFilterFailedEmails] = useState(false);
  const [filterPaused, setFilterPaused] = useState(false);
  const [filterRequireAttention, setFilterRequireAttention] = useState(false);
  const [filterIdle, setFilterIdle] = useState(false);
  const [filterFailedPayment, setFilterFailedPayment] = useState(false);
  const [filterFailedLetters, setFilterFailedLetters] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const [activeFilter, setActiveFilter] = useState(
    caseConstants.CASE_FILTER_NONE,
  );
  const [casesSorted, setCasesSorted] = useState(
    sidebarReducer[sidebarReducer.status.toLowerCase() + "Asc"],
  );
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [lastSidebarStatus, setLastSidebarStatus] = useState("CASES");
  const [openCasesReportPopup, setOpenCasesReportPopup] = useState(false);

  const [openAddCasePopup, setOpenAddCasePopup] = useState(false);
  const selectedCaseData =
    caseReducer.case[sidebarReducer.selections[sidebarReducer.status]];

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const urlParams = new URLSearchParams(location.search);
  const searchDebounceRef = useRef(null);

  const casesSearchTag = [
    { value: "case_id", label: "Case ID" },
    { value: "reference_number", label: "Reference Number" },
    { value: "domain", label: "Domain" },
    { value: "image", label: "Image" },
    { value: "tag", label: "Tag" },
  ];

  const caseStatesArray = Object.keys(caseStates);

  useEffect(() => {
    dispatch(customerActions.getCredits());
    if (pathParts[0] === "cases") {
      if (
        pathParts[1] &&
        caseStatesArray.some(
          (state) => state.toLowerCase() === pathParts[1].toLowerCase(),
        )
      ) {
        switch (pathParts[1].toLowerCase()) {
          case "active":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_ACTIVE,
                optionalFilter(),
              ),
            );
            break;

          case "paid":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_PAID,
                optionalFilter(),
              ),
            );
            break;
          case "standby":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_STANDBY,
                optionalFilter(),
              ),
            );
            break;
          case "cancelled":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_CANCELLED,
                optionalFilter(),
              ),
            );
            break;
          case "payment_processing":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_PAYMENT_PROCESSING,
                optionalFilter(),
              ),
            );
            break;
          case "valid_license":
            dispatch(
              sidebarActions.updateStatus(
                caseConstants.CASE_STATE_VALID_LICENSE,
                optionalFilter(),
              ),
            );
            break;

          default:
            history.push("/page_not_found");
            break;
        }
      } else {
        dispatch(sidebarActions.updateStatus("CASES", optionalFilter()));
      }
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const optionalFilter = () => {
    const urlFilter = urlParams.get("filter");
    switch (urlFilter) {
      case "unread_emails":
        activateFilter(caseConstants.CASE_FILTER_MAIL);
        return caseConstants.CASE_FILTER_MAIL;

      case "overdue_reminders":
        activateFilter(caseConstants.CASE_FILTER_REMINDER);
        return caseConstants.CASE_FILTER_REMINDER;

      case "uploaded_licenses":
        activateFilter(caseConstants.CASE_FILTER_UPLOADED_LICENSE);
        return caseConstants.CASE_FILTER_UPLOADED_LICENSE;

      case "failed_letters":
        activateFilter(caseConstants.CASE_FILTER_FAILED_LETTERS);
        return caseConstants.CASE_FILTER_FAILED_LETTERS;

      case "failed_emails":
        activateFilter(caseConstants.CASE_FILTER_FAILED_PAYMENT);
        return caseConstants.CASE_FILTER_FAILED_PAYMENT;

      case "paused":
        activateFilter(caseConstants.CASE_FILTER_PAUSED);
        return caseConstants.CASE_FILTER_PAUSED;

      case "require_attention":
        activateFilter(caseConstants.CASE_FILTER_REQUIRE_ATTENTION);
        return caseConstants.CASE_FILTER_REQUIRE_ATTENTION;

      case "idle":
        activateFilter(caseConstants.CASE_FILTER_IDLE_CASES);
        return caseConstants.CASE_FILTER_IDLE_CASES;

      default:
        return null;
    }
  };

  const createSearchObject = useCallback(
    (
      searchValue,
      selectedSearchTag,
      filterOverdueReminder,
      filterUnreadMails,
      filterUploadedLicenses,
      filterFailedLetters,
      filterFailedEmails,
      filterPaused,
      filterRequireAttention,
      filterIdle,
      filterFailedPayment,
    ) => {
      var searchObject = {};
      searchObject.sort = {
        key: "last_case_activity_timestamp",
        ascending:
          sidebarReducer[sidebarReducer.status.toLowerCase() + "Asc"] || false,
      };
      let filter = {
        unread_emails: filterUnreadMails,
        unchecked_licenses: filterUploadedLicenses,
        failed_letters: filterFailedLetters,
        overdue_reminders: filterOverdueReminder,
        failed_emails: filterFailedEmails,
        paused_scheduled_emails: filterPaused,
        action_required: filterRequireAttention,
        idle: filterIdle,
        failed_payments: filterFailedPayment,
      };
      if (searchValue && searchValue.trim().length > 0) {
        filter = {
          ...filter,
          search: {
            search_string: searchValue,
            search_mode: "contains",
            ...(selectedSearchTag
              ? { search_by: selectedSearchTag.value }
              : null),
          },
        };
        if (
          searchValue[0] === '"' &&
          searchValue[searchValue.length - 1] === '"'
        ) {
          filter.search.search_mode = "exact";
          filter.search.search_string = searchValue.slice(1, -1);
        }
      }

      searchObject.filter = filter;
      searchObject.paging = { page: 1, page_size: config.PAGE_SIZE };
      if (sidebarReducer.status !== "CASES") {
        searchObject.filter.state = sidebarReducer.status;
      }
      return searchObject;
    },
    [sidebarReducer],
  );

  const activateFilter = (filter) => {
    setActiveFilter(filter);
    setFilterMenuOpen(false);
    setFilterOverdueReminder(false);
    setFilterUnreadMails(false);
    setFilterUploadedLicenses(false);
    setFilterFailedEmails(false);
    setFilterIdle(false);
    setFilterPaused(false);
    setFilterRequireAttention(false);
    setFilterFailedPayment(false);
    setFilterFailedLetters(false);
    switch (filter) {
      case caseConstants.CASE_FILTER_MAIL:
        setFilterUnreadMails(true);
        break;
      case caseConstants.CASE_FILTER_REMINDER:
        setFilterOverdueReminder(true);
        break;
      case caseConstants.CASE_FILTER_UPLOADED_LICENSE:
        setFilterUploadedLicenses(true);
        break;
      case caseConstants.CASE_FILTER_FAILED_LETTERS:
        setFilterFailedLetters(true);
        break;
      case caseConstants.CASE_FILTER_FAILED_EMAIL:
        setFilterFailedEmails(true);
        break;
      case caseConstants.CASE_FILTER_FAILED_PAYMENT:
        setFilterFailedPayment(true);
        break;
      case caseConstants.CASE_FILTER_PAUSED:
        setFilterPaused(true);
        break;
      case caseConstants.CASE_FILTER_REQUIRE_ATTENTION:
        setFilterRequireAttention(true);
        break;
      case caseConstants.CASE_FILTER_IDLE_CASES:
        setFilterIdle(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // check if current page is a case page

    if (Object.keys(caseStates).indexOf(sidebarReducer.status) === -1) return;
    setCasesSorted(sidebarReducer[sidebarReducer.status.toLowerCase() + "Asc"]);
    var s;
    var localfilterOverdueReminder = filterOverdueReminder;
    var localfilterUnreadMails = filterUnreadMails;
    var localfilterUploadedLicenses = filterUploadedLicenses;
    var localfilterFailedEmails = filterFailedEmails;
    var localfilterPaused = filterPaused;
    var localfilterFailedPayment = filterFailedPayment;
    var localfilterFailedLetters = filterFailedLetters;

    switch (sidebarReducer.optionalFilter) {
      case caseConstants.CASE_FILTER_FAILED_EMAIL:
        localfilterFailedEmails = true;
        activateFilter(caseConstants.CASE_FILTER_FAILED_EMAIL);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_REMINDER:
        localfilterOverdueReminder = true;
        activateFilter(caseConstants.CASE_FILTER_REMINDER);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_MAIL:
        localfilterUnreadMails = true;
        activateFilter(caseConstants.CASE_FILTER_MAIL);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_FAILED_LETTERS:
        localfilterFailedLetters = true;
        activateFilter(caseConstants.CASE_FILTER_FAILED_LETTERS);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_UPLOADED_LICENSE:
        localfilterUploadedLicenses = true;
        activateFilter(caseConstants.CASE_FILTER_UPLOADED_LICENSE);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_PAUSED:
        localfilterPaused = true;
        activateFilter(caseConstants.CASE_FILTER_PAUSED);
        dispatch(sidebarActions.resetFilter());
        break;
      case caseConstants.CASE_FILTER_FAILED_PAYMENT:
        localfilterFailedPayment = true;
        activateFilter(caseConstants.CASE_FILTER_FAILED_PAYMENT);
        dispatch(sidebarActions.resetFilter());
        break;
      default:
        break;
    }

    s = createSearchObject(
      searchValue,
      selectedSearchTag,
      localfilterOverdueReminder,
      localfilterUnreadMails,
      localfilterUploadedLicenses,
      localfilterFailedLetters,
      localfilterFailedEmails,
      localfilterPaused,
      filterRequireAttention,
      filterIdle,
      localfilterFailedPayment,
    );
    setCurrentSearchObject(s);
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      dispatch(casesActions.getCases(s, true));
    }, 500);
    document.querySelector("#sb>div").scrollTop = 0;

    if (
      sidebarReducer.status !== lastSidebarStatus &&
      !sidebarReducer.optionalFilter
    ) {
      document.querySelector("#sb>div").scrollTop = 0;
      handleClearClick();
      setFilterOverdueReminder(false);
      setFilterUnreadMails(false);
      setFilterUploadedLicenses(false);
      setFilterFailedEmails(false);
      setFilterPaused(false);
      setFilterRequireAttention(false);
      setFilterFailedPayment(false);
      setFilterFailedLetters(false);

      setActiveFilter(caseConstants.CASE_FILTER_NONE);
    }
    setLastSidebarStatus(sidebarReducer.status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sidebarReducer.status,
    casesReducer.ascending,
    sidebarReducer.casesAsc,
    sidebarReducer.standbyAsc,
    sidebarReducer.paidAsc,
    sidebarReducer.activeAsc,
    sidebarReducer.cancelledAsc,
    sidebarReducer.valid_licenseAsc,
    sidebarReducer.payment_processingAsc,
    searchValue,
    filterOverdueReminder,
    filterUnreadMails,
    filterUploadedLicenses,
    filterFailedEmails,
    filterPaused,
    filterRequireAttention,
    filterFailedLetters,
    filterIdle,
    filterFailedPayment,
  ]);

  useEffect(() => {
    if (casesReducer.status.CASES_GET === "success") {
      if (
        caseReducer.count > 0 &&
        caseReducer.cases.length === casesReducer.count
      )
        setAllLoaded(true);
      dispatch(casesActions.clearStateMessage("CASES_GET"));
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casesReducer.status]);

  const loadFunc = useCallback(() => {
    if (
      !isLoading &&
      casesReducer.status.CASES_GET !== "request" &&
      casesReducer.count > 0 &&
      casesReducer.count !== casesReducer.cases.length
    ) {
      setIsLoading(true);
      let s = { ...currentSearchObject };
      if (!s.paging) s = createSearchObject();

      s.paging.page =
        Math.floor(casesReducer.cases.length / config.PAGE_SIZE) +
        1 +
        (casesReducer.cases.length % config.PAGE_SIZE > 0 ? 1 : 0);

      dispatch(casesActions.getCases(s));
      setCurrentSearchObject(s);
    }
  }, [
    casesReducer.cases.length,
    casesReducer.count,
    casesReducer.status.CASES_GET,
    createSearchObject,
    currentSearchObject,
    dispatch,
    isLoading,
  ]);

  useEffect(() => {
    setLoadNow(false);
    if (loadNow && allLoaded === false) {
      loadFunc();
    }
  }, [allLoaded, loadFunc, loadNow]);

  const hasMore = () => {
    return true;
    //return casesReducer.cases_count.all !== casesReducer.cases.length;
  };

  const handleSearchInputChange = (event) => {
    if (!selectedSearchTag) return;
    setSearchValue(event.target.value);
  };
  const handleSearchTagSelect = (option) => {
    setSelectedSearchTag(option);
    setSearchValue("");
  };
  const handleClearClick = () => {
    setSelectedSearchTag(null);
    setSearchValue("");
  };

  const handleOpenAddCasePopup = () => {
    dispatch(caseActions.clearStateMessage("CASE_ADD_FINDING"));
    setOpenAddCasePopup(true);
  };

  const handleFilterIconClicked = () => {
    if (activeFilter === caseConstants.CASE_FILTER_NONE) {
      setFilterMenuOpen(true);
    } else {
      activateFilter(caseConstants.CASE_FILTER_NONE);
    }
  };

  const handleSortToggle = () => {
    setCasesSorted(!casesSorted);
    localStorage.setItem(
      sidebarReducer.status.toLowerCase() + "Asc",
      !casesSorted,
    );
    dispatch(
      sidebarActions.sortCases(
        sidebarReducer.status.toLowerCase() + "Asc",
        !casesSorted,
      ),
    );
  };

  const renderActiveFilter = () => {
    return (
      <Button
        onClick={handleFilterIconClicked}
        className={styles.filterIconActive}
      >
        {renderActiveFilterElement()}
      </Button>
    );
  };

  const renderActiveFilterElement = () => {
    switch (activeFilter) {
      case caseConstants.CASE_FILTER_NONE:
        return (
          <>
            <FilterList></FilterList>
            <b style={{ marginLeft: "3px" }}>Filter</b>
          </>
        );
      case caseConstants.CASE_FILTER_MAIL:
        return (
          <>
            <Mail></Mail>
            <b style={{ marginLeft: "3px" }}>Unread Mails</b>
          </>
        );
      case caseConstants.CASE_FILTER_REMINDER:
        return (
          <>
            <EventBusy />
            <b style={{ marginLeft: "3px" }}>Reminder Overdue</b>
          </>
        );
      case caseConstants.CASE_FILTER_UPLOADED_LICENSE:
        return (
          <>
            <InsertDriveFileOutlined />
            <b style={{ marginLeft: "3px" }}>Uploaded Licenses</b>
          </>
        );

      case caseConstants.CASE_FILTER_FAILED_EMAIL:
        return (
          <>
            <Warning />
            <b style={{ marginLeft: "3px" }}>Failed Emails</b>
          </>
        );

      case caseConstants.CASE_FILTER_FAILED_LETTERS:
        return (
          <>
            <Warning />
            <b style={{ marginLeft: "3px" }}>Failed Letters</b>
          </>
        );
      case caseConstants.CASE_FILTER_FAILED_PAYMENT:
        return (
          <>
            <Warning />
            <b style={{ marginLeft: "3px" }}>Failed Payments</b>
          </>
        );

      case caseConstants.CASE_FILTER_PAUSED:
        return (
          <>
            <TimerOffTwoTone />
            <b style={{ marginLeft: "3px" }}>Paused Scheduled Emails</b>
          </>
        );

      case caseConstants.CASE_FILTER_REQUIRE_ATTENTION:
        return (
          <>
            <PanTool />
            <b style={{ marginLeft: "3px" }}>Require Attention</b>
          </>
        );
      case caseConstants.CASE_FILTER_IDLE_CASES:
        return (
          <>
            <AirlineSeatFlat />
            <b style={{ marginLeft: "3px" }}>Idle Cases</b>
          </>
        );

      default:
        return <></>;
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.case_list_container}>
        <div className={styles.search_case_container}>
          <SearchByType
            label={"Search"}
            searchValue={searchValue}
            selectedSearchTag={selectedSearchTag}
            casesSearchTag={casesSearchTag}
            onSearchInputChange={handleSearchInputChange}
            onSearchTagSelect={handleSearchTagSelect}
            onClearClick={handleClearClick}
          />
        </div>
        <div className={styles.bottom_cases_options}>
          <span>Sort order: </span>
          <span className={styles.sort_icon_container}>
            {sidebarReducer[sidebarReducer.status.toLowerCase() + "Asc"] ? (
              <ArrowUpward fontSize="small" onClick={handleSortToggle} />
            ) : (
              <ArrowDownward fontSize="small" onClick={handleSortToggle} />
            )}
          </span>
          <Tooltip title="Download Cases Report">
            <span
              className={styles.case_report_icon}
              onClick={() => setOpenCasesReportPopup(true)}
            >
              Export
            </span>
          </Tooltip>
        </div>
        <div className={styles.add_case_container}>
          <div className={styles.cases_top_container}>
            <div className={styles.add_case_button}>
              {" "}
              <Button onClick={handleOpenAddCasePopup} variant="outlined">
                Add New Case
              </Button>
            </div>
          </div>
          <div className={styles.filter_container}>
            <div>{renderActiveFilter()}</div>
            {activeFilter !== caseConstants.CASE_FILTER_NONE || searchValue ? (
              <div className={styles.filter_counter}>{casesReducer.count}</div>
            ) : (
              ""
            )}
          </div>

          {filterMenuOpen && (
            <>
              <ClickAwayListener onClickAway={() => setFilterMenuOpen(false)}>
                <Paper className={styles.filterMenuPaper}>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(
                        caseConstants.CASE_FILTER_REQUIRE_ATTENTION,
                      )
                    }
                  >
                    <PanTool
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Action Required
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_MAIL)
                    }
                  >
                    <Mail
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    ></Mail>
                    Unread Mails{" "}
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_REMINDER)
                    }
                  >
                    <EventBusyOutlined
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Overdue Reminder
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_UPLOADED_LICENSE)
                    }
                  >
                    <InsertDriveFileOutlined
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Uploaded Licenses
                  </div>

                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_FAILED_EMAIL)
                    }
                  >
                    <Warning
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Failed Emails
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_FAILED_LETTERS)
                    }
                  >
                    <Warning
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Failed Letters
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_FAILED_PAYMENT)
                    }
                  >
                    <Warning
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Failed Payments
                  </div>

                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_PAUSED)
                    }
                  >
                    <TimerOffTwoTone
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Paused Scheduled Emails
                  </div>
                  <div
                    className={styles.filterMenuRow}
                    onClick={() =>
                      activateFilter(caseConstants.CASE_FILTER_IDLE_CASES)
                    }
                  >
                    <AirlineSeatFlat
                      style={{ marginBottom: "-5px", marginRight: "8px" }}
                    />
                    Idle Cases
                  </div>
                </Paper>
              </ClickAwayListener>
            </>
          )}
        </div>
        <div
          id="scrollableDiv"
          style={{
            height: "calc(100vh - 288px)",
            overflow: "hidden",
            marginRight: "-10px",
            paddingRight: "10px",
          }}
        >
          <InfiniteScroll
            dataLength={casesReducer.cases.length}
            next={loadFunc}
            hasMore={hasMore}
            loader={
              <>
                {casesReducer.status.CASES_GET === "request" && (
                  <div className="loader" key={0}>
                    Loading ...
                  </div>
                )}
              </>
            }
            scrollableTarget="scrollableDiv"
            endMessage={<p>No more data to load.</p>}
          >
            <Scrollbar
              effectData={casesReducer.cases.length}
              id="sb"
              maxHeight="calc(100vh - 288px)"
              onScrollY={(ev) => {
                if (ev.target?.scrollTop / ev.target.scrollHeight > 0.94) {
                  if (
                    ev.target.children &&
                    (ev.target.children.length % config.PAGE_SIZE) - 2 === 0
                  )
                    setLoadNow(true);
                }
              }}
            >
              {casesReducer.cases.map((theCase, index) => {
                const selected =
                  sidebarReducer.selections[sidebarReducer.status] ===
                  theCase.id;
                return (
                  <div
                    key={"div_" + index}
                    className={
                      theCase.hidden
                        ? styles.case_row_folded
                        : styles.case_row_unfolded
                    }
                  >
                    <CasesRow
                      key={index}
                      data={theCase}
                      index={index}
                      selected={selected}
                    />
                  </div>
                );
              })}
            </Scrollbar>
          </InfiniteScroll>
        </div>
      </div>
      <div className={styles.case_details_container}>
        <Scrollbar
          options={{ suppressScrollX: true }}
          maxHeight="calc(100vh - 141px)"
        >
          <CaseDetails data={selectedCaseData} />
        </Scrollbar>
      </div>
      <AddCasePopup
        open={openAddCasePopup}
        close={() => setOpenAddCasePopup(false)}
      />
      <CasesReportPopup
        open={openCasesReportPopup}
        close={() => setOpenCasesReportPopup(false)}
      />
    </div>
  );
}

export default Cases;
